import api from 'api/api';
import downloadReceipt from 'utils/downloadReceipt';
import {
  IAccountLookup,
  ILocalLookupRes,
  ITransferCharge,
  IBulkTransferBody,
  IOtherLookupRes,
  IGetBankBranches,
} from './BulkManualEntry.model';

export const bulkTransferSubmit = (body: IBulkTransferBody) => api.post('transfer/bulk', body);

export const lookupLocalAccount = (accountNumber: string): Promise<IAccountLookup> =>
  api
    .get<ILocalLookupRes>(`transfer/lookupaccount?accountNumber=${accountNumber}`)
    .then((data) => ({ name: data.accountName, beneficiaryId: undefined }));

export const lookupOtherAccount = (accountNumber: string,
  bankCode: string, sourceAccount: string): Promise<IAccountLookup> =>
  api
    .post<IOtherLookupRes>('transfer/otherbank/namelookup', {
      destinationAccount: accountNumber,
      institutionId: bankCode,
      sourceAccount,
    })
    .then((data) => ({ name: data.name, beneficiaryId: data.beneficiaryId }));

export const getReceipt = (transactionID: number) =>
  api.get(`/transaction/receipt?trnxID=${transactionID}`).then(downloadReceipt);

export const getTransferCharge = (amount: string | number, type: string) =>
  api.get<ITransferCharge>(`transfer/otherbank/charge?amount=${amount}&type=${type}`, {}, false, false);

export const fetchBankBranch = (code: string) =>
  api.get<IGetBankBranches>(`transfer/bankBranch?bankSortCode=${code}`, {}, true, false).then((data) => ({ data }));
